import { patchAssetPayload } from '../actions';
import { orchestrator } from 'satcheljs';
import isProjectPreview from '../selectors/isProjectPreview';
import patchAsset from '../utils/patchAsset';

orchestrator(
    patchAssetPayload,
    ({
        projectId,
        assetId,
        payload,
        newTaskId,
        isPartialPayload,
        payloadId,
        currentPayload,
        partialOriginalAsset,
    }) => {
        const fullPayload = isPartialPayload
            ? { ...(currentPayload as any), ...(payload as any) }
            : payload;

        patchAsset(
            projectId,
            assetId,
            { payload: fullPayload, ...newTaskId },
            partialOriginalAsset,
            asset => asset.payloadId == payloadId && !isProjectPreview(projectId)
        );
    }
);
